<script setup lang="ts">
import { getSiteMapStructures } from '@/services/eos/site-map'
import type { ISiteMapStructure } from '@/types/eos/SiteMap'
import type { ISiteMapStructureFilters } from '@/types/eos/filters'
import { ElMessage } from 'element-plus'
import type { OptionType } from 'element-plus/es/components/select-v2/src/select.types.mjs'
import { ref, watch } from 'vue'

const props = withDefaults(defineProps<{ placeholder?: string; siteId?: string }>(), {
  placeholder: 'Select Structure',
})

const selectedValue = defineModel<ISiteMapStructure>()

const filterLoading = ref(false)
const filterOptions = ref<OptionType[]>([])

const filterValues = async (query: string) => {
  try {
    filterLoading.value = true

    const filters: ISiteMapStructureFilters = {
      page: 1,
      per_page: 1000,
      order_by: 'name',
      site_id: props.siteId,
    }

    if (query) {
      filters.name = query
    }

    const filteredResources = await getSiteMapStructures(filters)
    filterOptions.value = filteredResources.data.map((res: ISiteMapStructure) => {
      return {
        label: res.name,
        value: res,
      }
    })
  } catch {
    ElMessage.error('Failed to filter structures')
    filterOptions.value = []
  } finally {
    filterLoading.value = false
  }
}

// Add a watch to check selectedEquipmentType changes
watch(selectedValue, () => {
  if (selectedValue.value) {
    filterOptions.value.push({
      label: selectedValue.value.name,
      value: selectedValue.value,
    })
  }
})
</script>

<template>
  <el-select-v2
    v-model="selectedValue"
    :options="filterOptions"
    :loading="filterLoading"
    remote
    :remote-method="filterValues"
    filterable
    clearable
    value-key="id"
    :placeholder="props.placeholder"
    loading-text="Loading..."
  />
</template>
